import slice from './slice.collection';
import * as collectionTypes from './types.collection';
import * as collectionUtils from './collectionUtils';

export const { reducer: collectionState, actions: collectionActions } = slice;
export { collectionTypes, collectionUtils };
export { default as collectionSaga } from './saga.collection';
export { default as collectionSelector } from './selector.collection';
export default slice;
